import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import RepresentativeCompany from './representative-company';
import RepresentativeCompanyDetail from './representative-company-detail';
import RepresentativeCompanyUpdate from './representative-company-update';
import RepresentativeCompanyDeleteDialog from './representative-company-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={RepresentativeCompanyUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={RepresentativeCompanyUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={RepresentativeCompanyDetail} />
      <ErrorBoundaryRoute path={match.url} component={RepresentativeCompany} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={RepresentativeCompanyDeleteDialog} />
  </>
);

export default Routes;
